/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAttributionTagFromJSON, ApiAttributionTagToJSON, } from './ApiAttributionTag';
import { ApiBucketGroupFromJSON, ApiBucketGroupToJSON, } from './ApiBucketGroup';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiProjectDefaultFromJSON, ApiProjectDefaultToJSON, } from './ApiProjectDefault';
export function ApiBucketFromJSON(json) {
    return ApiBucketFromJSONTyped(json, false);
}
export function ApiBucketFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        '_default': !exists(json, 'default') ? undefined : ApiProjectDefaultFromJSON(json['default']),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'groups': !exists(json, 'groups') ? undefined : (json['groups'].map(ApiBucketGroupFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(ApiAttributionTagFromJSON)),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiBucketToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'default': ApiProjectDefaultToJSON(value._default),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'groups': value.groups === undefined ? undefined : (value.groups.map(ApiBucketGroupToJSON)),
        'id': value.id,
        'name': value.name,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'tags': value.tags === undefined ? undefined : (value.tags.map(ApiAttributionTagToJSON)),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
